/**
 * Definindo classes CSS para impressão do resultado da avaliação
 */
const styles = (theme) => ({
    titulo: {
        fontSize: '2.5rem',
        fontWeight: 400
    },
    secao: {
        fontSize: '1.7rem',
        fontWeight: 500
    },
    label: {
        fontSize: '1.2rem',
        fontWeight: 500
    },
    texto: {
        fontSize: '1rem',
        textAlign: 'justify',
        whiteSpace: 'pre-line'
    },
    imagem: {
        maxWidth: '100%',
        minWidth: '1px'
    },
    corpoTabela: {
    },
    tabelaResultado: {
        //Fixa o layout, o tamanho do grid é definido na página
        tableLayout: 'fixed',
        '& td': {
            minWidth: '150px'
        }
    },
    tituloSecao: {
        '& td': {
            paddingTop: theme.spacing(5),
            borderBottomColor: theme.palette.grey['A700']
        }
    },
    tituloQuestao: {
        '& td': {
            paddingBottom: theme.spacing(0),
            borderBottomWidth: 0
        }
    },
    linhaOpcao: {
        '& td': {
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(1),
            borderBottomWidth: 0
        }
    },
    linhaOpcaoUltima: {
        '& td': {
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(1)
        }
    }
});

export default styles;